export default __webpack_public_path__ + "static/media/1740.12580418.png";